<template>
  <vg-field
      v-bind="$attrs"
      v-on="$listeners"
      :label="label"
      :vertical="imageFiles && imageFiles.length > 0"
      :hint="hint"
  >
    <vg-image-uploader
        :class="{maximum: !imageFiles || imageFiles.length <= 0}"
        :file-list="imageFiles"
        multiple
        :max-count="fieldRule && fieldRule.max || 5"
        :before-delete="(file,detail)=>delImg(file,detail)"
        :after-read="(file)=>tpOnAfterRead(file)"
        :max-size="10 * 1024 * 1024"
        @oversize="onOversize"
    >
      <!--      <div class="addPhotoDiv">-->
      <!--        <van-image width="50" height="50" :src="imgSrc" style="margin-top: 0px;"/>-->
      <!--      </div>-->
    </vg-image-uploader>
  </vg-field>
</template>

<script>
import {Dialog, Toast} from "vant";
import samplePhotos from "@/assets/myElectronicPass/samplePhotos.png";
import {client} from "@/libraries/http";
import {compressA4Document} from "@/libraries/image-converter";
import AddPhoto from "@/assets/myElectronicPass/addPhoto.svg";
import idGenerate from "@/libraries/id-generate";
import VgImageUploader from "@/components/Commons/VgImageUploader.vue";
import VgField from "@/components/Commons/VgField.vue";

const onAfterRead = (file) => {
  console.log('------------------')
  console.log(file, "uploadFile")
  const formData = new FormData();
  formData.append('file', file);
  formData.append('type', '2');
  formData.append('desciption', '');
  formData.append('systemType', 'SERVER_END');
  console.log(formData, "uploadformData")
  return client.post("/api/h5/file_app/upload", formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
      'Disable-Loading': 'Yes'
    }
  }).then(rsp => {
    console.log(rsp)
    return rsp;
  })
};

export default {
  name: "DpApplicationTpOvertimeApprovalPhotoField",
  components: {
    VgField,
    VgImageUploader,
    // "van-image": Image,
  },
  props: {
    label: String,
    value: [],
    disabled: Boolean,
    fieldRule: Object,
  },
  data() {
    return {
      SamplePhotos: samplePhotos,
      imgSrc: AddPhoto,
      imageFiles: [],
      init: false
    }
  },
  computed: {
    isUploaded() {
      // 如果有图片未上传完成则为假
      return !this.imageFiles.find(file => file.status !== 'done' && !file.url);
    },
    hint() {
      const max = this.fieldRule && this.fieldRule.max || 5
      return `(最多${max}张)`
    }
  },
  created() {
    this.value && this.initImageFiles(this.value)
  },
  watch: {
    value(newValue) {
      this.initImageFiles(newValue)
    },
  },
  methods: {
    initImageFiles(imageFiles) {
      this.imageFiles = imageFiles.map(url => ({url, isImage: true}))
    },
    input() {
      this.$emit('input', this.imageFiles.map(file => file.url))
    },
    delImg(file, detail) {
      return new Promise((resolve, reject) => {
        Dialog.confirm({
          message: '提示：是否确认删除？'
        }).then(() => {
          // const imageFiles = [...this.imageFiles];
          // imageFiles.splice(detail.index, 1);
          // const imageFiles = [...this.imageFiles];
          this.imageFiles.splice(detail.index, 1);
          this.input()
          this.$nextTick(() => {
            this.$emit('update:uploaded', this.isUploaded);
          });
          this.$toast.success('删除成功')
          resolve()
        }).catch(error => {
          this.$toast.fail('已取消')
          reject(error)
        })
      })
    },
    // personalPhotoOnAfterRead(file) {
    //   vgWatermark(file.file).then(blob => {
    //     let filea = file.file;
    //     let aaa = new window.File([blob], filea.name, {type: filea.type})
    //     onAfterRead(aaa).then(res => {
    //       this.input(res.data);
    //     });
    //   });
    // },
    tpOnAfterRead(fileWrapper) {
      fileWrapper.id = idGenerate();
      fileWrapper.status = 'uploading';
      fileWrapper.message = '上传中...';
      const imageFiles = this.imageFiles || [];
      imageFiles.push(fileWrapper);
      console.log(fileWrapper)
      this.$emit('update:uploaded', this.isUploaded)
      compressA4Document(fileWrapper.file)
          .then(blob => {
            let filea = fileWrapper.file;
            return new window.File([blob], filea.name, {type: filea.type})
          })
          .then(file => onAfterRead(file))
          .then(res => {
            fileWrapper.url = res.data;
            fileWrapper.status = 'done';
            fileWrapper.message = '';
            // this.input(this.value)
          })
          .catch((e) => {
            console.log(e);
            fileWrapper.status = 'failed';
            fileWrapper.message = '上传失败';
          })
          .finally(() => {
            this.input()
            this.$emit('update:uploaded', this.isUploaded)
          })
    },
    onOversize(file) {
      console.log(file);
      Toast('文件大小不能超过 10MB');
    }
  }
}
</script>

<style scoped>
</style>
